<template>
  <div style="padding-top: .98rem">
    <topbar :hideBackBtn="true" text="温馨提示"></topbar>
    <div class="msg-box">
      <div>申请已提交,请耐心等待审核结果</div>
    </div>
  </div>
</template>
<script>

import topbar from 'components/topbar'

export default {
  data() {
    return {
      defaultMsg: 'SUBMITTED',
      message: '暂无消息',
      msgMap: {
        'SUBMITTED': '申请已提交,请耐心等待审核结果'
      }
    }
  },
  components: { topbar },
  created() {
    const msg = this.$route.query.msg
    if (!this.$utils.isBlank(msg)) this.defaultMsg = msg
    const m = this.msgMap[msg]
    if (m) this.message = m
  },
  methods: {
  },
}
</script>
<style>
.msg-box {
  margin-top: 3rem;
  height: 3rem;
  padding: 0.4rem;
  display: flex;
  align-items: center;
  background: #fff;
  font-size: 0.4rem;
  color: gray;
}
.msg-box div {
  width: 100%;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/application/message.vue